const { giftWithPurchaseProductCache } = window.BAO.Caches
const { Controller: GiftWithPurchaseController } = window.BAO.GiftWithPurchase

/**
 * @typedef {CustomEvent<{
 *   product: Record<string, unknown>,
 *   variant?: Record<string, unknown>,
 * }>} GiftWithPurchaseProductReplaceEvent
 */

class GiftWithPurchaseProducts extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this._disabled = false

    this.updateProductVisibility()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this,
      'gift-with-purchase:product:replace',
      this.replaceProduct.bind(this),
    )

    this.listeners.add(
      document.body,
      'gift-with-purchase:update',
      this.updateProductVisibility.bind(this),
    )

    this.listeners.add(
      this,
      'gift-with-purchase:product:before-add',
      this.handleBeforeAdd.bind(this),
    )
    this.listeners.add(
      this,
      'gift-with-purchase:product:after-add',
      this.handleAfterAdd.bind(this),
    )
  }

  handleBeforeAdd () {
    this.setAttribute('aria-busy', true)

    this.els.product.elements.forEach(element => {
      element.disabled = true
    })
  }

  handleAfterAdd () {
    this.setAttribute('aria-busy', false)

    this.els.product.elements.forEach(element => {
      element.disabled = false
    })
  }

  /** @param {GiftWithPurchaseProductReplaceEvent} event */
  async replaceProduct (event) {
    const { product, variant } = event.detail
    /** @type {HTMLElement} */
    const elementToReplace = event.target

    /**
     * When `variant` is not defined (because one hasn't been selected,
     * for example), we only pass the product handle to the cache
     */
    const cacheKey = [product.handle, variant?.id].filter(Boolean).join('::')

    const replacementHtml = await giftWithPurchaseProductCache.get(cacheKey)
    elementToReplace.outerHTML = replacementHtml
  }

  updateProductVisibility () {
    GiftWithPurchaseController.activeRules.forEach(rule => {
      const isVisible =
        rule.isEligible &&
        !rule.hasBeenClaimed &&
        !GiftWithPurchaseController.hasBeenClaimed()

      this.els.item.elements
        .filter(item => item.dataset.ruleId === rule.id)
        .forEach(item => item.setAttribute('aria-hidden', !isVisible))
    })

    const visibleItems = this.els.item.elements.filter(
      item => item.getAttribute('aria-hidden') !== 'true',
    )

    if (visibleItems.length === 0) {
      this.hide()
    } else {
      this.show()
    }
  }

  show () {
    const parent = this.externalEls.drawer.element

    parent.setAttribute('aria-hidden', 'false')
  }

  hide () {
    const parent = this.externalEls.drawer.element

    parent.isOpen = false
    parent.setAttribute('aria-hidden', 'true')
  }
}

if (!window.customElements.get('gift-with-purchase-products')) {
  window.customElements.define(
    'gift-with-purchase-products',
    GiftWithPurchaseProducts,
  )
}
